import React, { useState,Component } from 'react';
import axios from 'axios';
import { setUserSession } from '../utils/Common';
import { BrowserRouter, Switch, Route, NavLink } from 'react-router-dom';
import {Footer} from 'react-materialize';
import DataService from "../services/data.service";
import Message from '../component/Message';
import Loading from '../component/loading';
import { withRouter } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory'

class Success_paid extends Component {
  constructor(props) {
    super(props);

    this.state = {
     
     
    }
   
   
  }
  componentDidMount() 
  {
 
  }

    render() {
        return (

        <div id="popup1" class="overlay_cus_suceess">
        <div class="message_popup_loading">
            <h3>Oh Snap!</h3>
            {/* <a class="close hand" onClick={props.handle_message}>&times;</a> */}
            <div class="content text-center mt-5">
            Looks like something went wrong while processing your payment.</div>
            <a href="/">Return to payment page.</a>           
        </div>
        </div>
          );
    }
  
}
export default withRouter(Success_paid);
